import carEvents from './../config/carEvents';
import appEvents from 'constants/appEvents.constant';

export default function CarsFiltersController(
    $scope,
    $rootScope,
    $window,
    $timeout,
    carsFactory,
    filterDetector,
    searchData
) {
    'ngInject';

            const initialFilters = carsFactory.getFilters();
            const searchFilters = searchData.searchResults.filters;
            let defaultFilter = false;

            const vm = this;
            Object.assign(vm, {
                $onInit,
            });

            function $onInit() {
                $scope.showFiltersCars = true;
                $scope.filters = searchFilters;
                $scope.updatedFilters = initialFilters;
                setFilterPrice(searchFilters.TotalPrice);

                filterDetector.getWindowWidth(sizeHandler);

                $scope.toggleControl = function(param) {
                    $scope.$broadcast(appEvents.REFRESH_SLIDER);
                    $scope[param] = !$scope[param];
                };

                $scope.clearCarsFilters = function() {
                    defaultFilter = true;
                    carsFactory.resetFilters();
                    $scope.updatedFilters = carsFactory.getFilters();
                    carsFactory.applyFilters($scope.updatedFilters);
                };

                $scope.priceRangeSlider = {
                    floor: searchFilters.TotalPrice[0],
                    ceiling: searchFilters.TotalPrice[1],
                    model: initialFilters.TotalPriceFilter[0] || searchFilters.TotalPrice[0],
                    range: initialFilters.TotalPriceFilter[1] || searchFilters.TotalPrice[1],
                };

                $scope.isFilterDataExists = function(filter) {
                    return !_.isEmpty(filter);
                };
                subscribe();
            }

            function setFilterPrice(price) {
                $scope.updatedFilters.TotalPriceFilter = angular.copy(price);
            }

            function subscribe() {
                $scope.$on(carEvents.TRIGGER_CAR_FILTERS, triggerCarFilters);
                $scope.$on(carEvents.CLICK_CAR_MARKER, carMarkerClick);
                $scope.$on(carEvents.CLEAR_CAR_FILTERS, $scope.clearCarsFilters);
                $timeout(() => $scope.$watch('updatedFilters', updateFilters, true));
            }

            function triggerCarFilters() {
                $scope.toggleControl('showFiltersCars');
                $scope.$broadcast(appEvents.REFRESH_SLIDER);
            }

            function carMarkerClick(event, marker) {
                const result = $scope.filters.Area.filter(function(obj) {
                    return obj.Value === marker.address;
                });
                if (result && $scope.updatedFilters.AreaFilter.indexOf(marker.address) === -1) {
                    $scope.updatedFilters.AreaFilter.push(marker.address);
                }
            }

            function updateFilters(newValue, oldValue) {
                if (newValue !== oldValue) {
                    $rootScope.$broadcast('applyFilters', newValue);

                    $window.scrollTo(0, 0);

                    if (defaultFilter === false) {
                        carsFactory.filtersApplied = true;
                    } else {
                        defaultFilter = false;
                    }
                }
            }

            function sizeHandler(status) {
                $scope.isTotalPriceCollapsed = status;
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/controllers/carsFiltersCtrl.js